import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";

@Component({
    selector: "app-create-decision-pop-up",
    templateUrl: "./create-decision-pop-up.component.html",
    styleUrls: ["./create-decision-pop-up.component.scss"],
    standalone: false
})
export class CreateDecisionPopUpComponent implements OnInit {
  text = "Create Decision";
  isEditMode = false;

  decisionForm!: FormGroup;

  sourceList = [
    "Drug Safety Commitee decision",
    "Group Head decision	",
    "Safety team decision",
  ];

  // rankList = ["High", "Medium", "Low"];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateDecisionPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorageSettings: LocalStorageSettingsService,
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.handleMode();
    this.setupSafetyValidation();
  }

  initializeForm() {
    this.decisionForm = this.fb.group({
      effectiveDate: [null, Validators.required],
      source: [null, Validators.required],
       otherSource: [""], // 👈 added
      // decisionRank: [null, [Validators.required, Validators.min(1), Validators.max(10)]],
      decision: ["", Validators.required],
      decisionDescription: ["", Validators.required],

      dhpc: [false],
      dil: [false],
      safetyText: [""],
    });
    // 👇 Listen for source changes
  this.decisionForm.get('source')?.valueChanges.subscribe(value => {
    const otherSourceControl = this.decisionForm.get('otherSource');

    if (value === 'Others') {
      otherSourceControl?.setValidators([Validators.required]);
    } else {
      otherSourceControl?.clearValidators();
      otherSourceControl?.setValue('');
    }

    otherSourceControl?.updateValueAndValidity();
  });
  }

  handleMode() {
    if (this.data?.mode === "edit") {
      this.isEditMode = true;
      this.text = "Edit Decision";

      if (this.data?.formData) {
        this.decisionForm.patchValue(this.data.formData);
      }
    }
  }

  setupSafetyValidation() {
    this.decisionForm.get("dhpc")?.valueChanges.subscribe(() => {
      this.updateSafetyValidation();
    });

    this.decisionForm.get("dil")?.valueChanges.subscribe(() => {
      this.updateSafetyValidation();
    });
  }

  updateSafetyValidation() {
    const dhpc = this.decisionForm.get("dhpc")?.value;
    const dil = this.decisionForm.get("dil")?.value;
    const safetyText = this.decisionForm.get("safetyText");

    if (dhpc || dil) {
      safetyText?.setValidators([Validators.required]);
    } else {
      safetyText?.clearValidators();
    }

    safetyText?.updateValueAndValidity();
  }

  onSubmit() {
    if (this.decisionForm.invalid) {
      this.decisionForm.markAllAsTouched();
      return;
    }

  const dnsName = this.localStorageSettings.getSettings("dnsName");
  const workspaceId = this.localStorageSettings.getSettings("WorkspaceId");

  const payload = {
    ...this.decisionForm.value,
    dnsid: dnsName,
    workspaceId: workspaceId,
  }

    this.dialogRef.close(payload);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
